import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGet } from 'hooks';
import { getListsForUser, getOrgListsForUser } from 'services/api';
import { getActiveList } from 'selectors/lists';
import { setModal, setAddToTarget } from 'actions/lists';
import { Select } from 'components/common';
import { LABEL_BUTTON_ADD_NEW_LIST } from 'components/common/labelConstants';

import { views } from '../constants';
import listRenderOption from 'components/common/Lists/ListRenderOptions';

export const AddToList = ({
  disabled,
  onCreateNewItemList,
  view = views.researchers,
  placeholder = 'Add to List',
  width = 150,
}) => {
  const dispatch = useDispatch();
  const activeList = useSelector(getActiveList);
  const activeListRef = useRef();
  const [{ res: editableLists, loading }, getEditableLists] = useGet({
    url: view === views.researchers ? getListsForUser : getOrgListsForUser,
    query: { onlyEditable: true },
  });

  useEffect(() => {
    if (activeList && activeList.id) {
      if (activeListRef.current && activeListRef.current.id === activeList.id) {
        return;
      }

      getEditableLists();
      activeListRef.current = activeList;
    }
  }, [activeList, getEditableLists]);

  const handleAddTo = id => {
    if (id === 'no_lists') return;
    const targetList = editableLists.find(l => l.id === id);

    dispatch(setAddToTarget(targetList));
    dispatch(setModal('addTo'));
  };

  const addToListOptions =
    editableLists && editableLists.length > 0
      ? editableLists
          .filter(l => l.id !== activeList?.id)
          .map(l => ({
            label: l.name,
            value: l.id,
            description: l.description,
          }))
      : [{ label: 'No lists available', value: 'no_lists' }];

  if (addToListOptions.length === 0) {
    addToListOptions.push({ label: 'No lists available', value: 'no_lists' });
  }
  const isDisabled = disabled || loading;

  return (
    <Select
      showSearch
      size='small'
      placeholder={placeholder}
      value={placeholder}
      onCreateNewItem={onCreateNewItemList}
      buttonText={LABEL_BUTTON_ADD_NEW_LIST}
      options={addToListOptions}
      style={{ width }}
      renderOption={(o, i) => listRenderOption({ ...o }, i)}
      dropdownStyle={{ minWidth: 300 }}
      filterOption={(input, option) =>
        option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      disabled={isDisabled}
      onChange={handleAddTo}
      disableTooltip
    />
  );
};
